import global from "../prototype/global.js";
import Configuration from "../prototype/Configuration.js";
import Server from "../prototype/Server.js";
import Internationalization from "../prototype/Internationalization";

// const log = global.log.getLogger("f_mtac_routes.index");

global.app.bootstrap.register_module({
    name: "dom_loaded",
    deps: [],
    init: async () => {
        await (new Promise((resolve) => {
            $(document).ready(function(){
                resolve();
            });
        }));
    }
});

let init = async () => {
    // AGPOC-4769: Force loading Server module before Internationalization as it is done in landing.js (for Agnet case Server module was not loaded before Internationalzation)
    global.configuration = new Configuration();
    await global.configuration.init();
    global.server = new Server();
    global.server.authentication.auto_register = false;
    await global.server.init();
    global.internationalization = new Internationalization(false);
    await global.internationalization.init();

    await global.app.bootstrap.boot();
    global.event_bus.publish("init");
};
let finalize = () => {};

export default {
    init: init,
    finalize: finalize
};


